module.exports = __webpack_public_path__ + "img/tmba.5ab689cd.png";